import React from 'react';

import './GlobalLoader.scss';

export default function GlobalLoader(): JSX.Element {
  return (
    <div className="GlobalLoader">
      <div className="LoaderAnimation">
        <div />
        <div />
      </div>
    </div>
  );
}
